import * as React from "react"
const SvgCrossroads = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 21.429v-3H6.825a1.98 1.98 0 0 1-1.4-.575L3.7 16.129a.96.96 0 0 1-.3-.7q0-.4.3-.7l1.725-1.725a1.98 1.98 0 0 1 1.4-.575H11v-2H5a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 9.43v-4a.97.97 0 0 1 .287-.713A.97.97 0 0 1 5 4.43h6v-1a.97.97 0 0 1 .287-.713A.97.97 0 0 1 12 2.43q.424 0 .712.287.288.288.288.713v1h4.175a1.98 1.98 0 0 1 1.4.575L20.3 6.729q.3.3.3.7t-.3.7l-1.725 1.725a1.98 1.98 0 0 1-1.4.575H13v2h6q.424 0 .712.287.288.288.288.713v4q0 .424-.288.712a.97.97 0 0 1-.712.288h-6v3q0 .424-.288.712a.97.97 0 0 1-.712.288.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712m-5-13h11.175l1-1-1-1H6zm.825 8H18v-2H6.825l-1 1z" />
  </svg>
)
export default SvgCrossroads
